/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/DownloadDetails
 */
export interface DownloadDetailsRequestBuilder extends BaseRequestBuilder<DownloadDetailsRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     get(requestConfiguration?: RequestConfiguration<DownloadDetailsRequestBuilderGetQueryParameters> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<DownloadDetailsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface DownloadDetailsRequestBuilderGetQueryParameters {
    bookingNumber?: string;
    passengerDataFileId?: number;
}
/**
 * Uri template for the request builder.
 */
export const DownloadDetailsRequestBuilderUriTemplate = "{+baseurl}/Dashboard/DownloadDetails?passengerDataFileId={passengerDataFileId}{&bookingNumber*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const DownloadDetailsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: DownloadDetailsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
    },
};
/* tslint:enable */
/* eslint-enable */
